import { render, staticRenderFns } from "./autoSuggestions.vue?vue&type=template&id=2634105c&"
import script from "./autoSuggestions.vue?vue&type=script&lang=js&"
export * from "./autoSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports